import { Stack } from '@mui/system';
import { EnumService, mapService } from 'tdc-web-backend/enums/enums';
import { Dispatch, SetStateAction } from 'react';
import CompanyServicesEditModal from './components/CompanyServicesEditModal';
import CustomChip from '../../../../../../../../../components/custom-chip/CustomChip';
import { truncate } from '../../../../../../../../../utils/helpers';
import useUserCompany from '../../../../../../../../../utils/hooks/useUserCompany';
import { CHIP_LABEL_TRUNCATE_VALUE } from '../../../../../../../../../utils/constants';
import { useTranslation } from 'react-i18next';

interface ServicesProps {
  isEditModalOpen: boolean;
  setIsEditModalOpen: Dispatch<SetStateAction<boolean>>;
}

const Services = ({ isEditModalOpen, setIsEditModalOpen }: ServicesProps) => {
  const { t } = useTranslation();
  const { company: companyData } = useUserCompany();

  return (
    <Stack
      direction="row"
      gap={1}
      flexWrap="wrap"
      alignItems="flex-start"
      justifyContent="flex-start"
    >
      <>
        {isEditModalOpen && (
          <CompanyServicesEditModal
            isEditModalOpen={isEditModalOpen}
            setIsEditModalOpen={setIsEditModalOpen}
          />
        )}

        {companyData?.services?.map((service: EnumService) => (
          <CustomChip
            key={service}
            tooltipTitle={t(mapService.get(service) ?? '', { ns: 'enum' })}
            label={
              service &&
              truncate(
                t(mapService.get(service) ?? '', { ns: 'enum' }),
                CHIP_LABEL_TRUNCATE_VALUE as number,
              )
            }
            sx={{ width: 'fit-content', textTransform: 'capitalize' }}
          />
        ))}
      </>
    </Stack>
  );
};

export default Services;
